module.exports = __webpack_public_path__ + "img/authen_fail.c09120e3.png";